export default __webpack_public_path__ + "media/pro/pay_with_paypal@2x-204ce2fb.png";